import { Component } from '@angular/core';

@Component({
    selector: 'app-professionals',
    templateUrl: './professionals.component.html',
    styleUrls: ['./professionals.component.css'],
    standalone: false
})
export class ProfessionalsComponent {

}
